import { StringFilter, DateFilter, IdFilter } from "@react3l/advanced-filters";
import { ModelFilter } from "@react3l/react3l/core";

export class DeviceTypeFilter extends ModelFilter {
  public id?: IdFilter = new IdFilter();
  public code?: StringFilter = new StringFilter();
  public name?: StringFilter = new StringFilter();
  public createdAt?: DateFilter = new DateFilter();
  public categoryId?: IdFilter = new IdFilter();
}
